export const formatRelativeTime = (dateString: string | null | undefined): string => {
  if (!dateString) return 'Never';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  return `${diffDays}d ago`;
};

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

export const getProcessingStatusInfo = (status: string): { label: string; color: string; canProcess: boolean } => {
  switch (status) {
    case 'embedded':
      return { label: 'Ready', color: 'bg-green-100 text-green-800', canProcess: false };
    case 'pending':
      return { label: 'Needs Processing', color: 'bg-gray-100 text-gray-600', canProcess: true };
    case 'downloading':
    case 'summarizing':
    case 'embedding':
      return { label: 'Processing...', color: 'bg-blue-100 text-blue-800', canProcess: false };
    case 'download_failed':
    case 'summarize_failed':
    case 'embed_failed':
      return { label: 'Failed', color: 'bg-red-100 text-red-800', canProcess: true };
    default:
      return { label: status, color: 'bg-gray-100 text-gray-600', canProcess: true };
  }
};

export const getDecisionOutcomeColor = (status: string): string => {
  switch (status?.toLowerCase()) {
    case 'upheld':
      return 'bg-green-100 text-green-800';
    case 'not upheld':
      return 'bg-red-100 text-red-800';
    case 'partly upheld':
    case 'partially upheld':
      return 'bg-yellow-100 text-yellow-800';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

export const sectorOptions = ['Insurance', 'Banking', 'Investment', 'Pensions'] as const;
